import React, {useEffect, useState} from 'react'
import Ajax from '../../../../../../helpers/Ajax';
import TableLoader from '../../../../../UI/Dashboard/TableLoader';
import DataView from '../../../../../UI/Dashboard/DataView';
import TableContainer from '../../../../../UI/Dashboard/TableContainer';
import { Helmet } from 'react-helmet-async';
import ContentLayout from '../../../../../Common/ContentLayout';
import EditButton from '../../../../../UI/Dashboard/EditButton';
import DeleteButton from '../../../../../UI/Dashboard/DeleteButton';

export default function HomefestVideoList() {
    const [dataList, setDataList] = useState(null)
    useEffect(()=>{
    const getResponse = setTimeout(function(){  
        (async()=>{ 
        const response = await Ajax({
            url: `/landingPage/review`,
            token: true,
        })
        if(response.data.status === "SUCCESS!"){
            setDataList(response.data.result)
        }
        })()
    },100) 
    return()=>{
        clearInterval(getResponse)
    }
    },[])

    return (
    <ContentLayout title='Video List' addNew='/admin/page/homefest/video/add-new'>
        <div className="row">
        <Helmet>
            <title>Video List</title>
        </Helmet>
        <DataView title="Video List">
            <TableContainer>
                <thead>
                    <tr>
                        <td className="text-center">S.No</td>
                        <td className="text-start">Title</td>
                        <td className="text-start">Youtube</td>
                        <td className="text-center">Active</td>
                        <td className="text-center">Edit</td>
                        <td className="text-center">Delete</td>
                    </tr>
                </thead>
                <tbody>
                    {dataList == null ? 
                    <TableLoader cols={6}/> : dataList.length === 0 ? 
                    <tr>
                        <td colSpan={6} className="text-center">Data not available</td>
                    </tr> : dataList.map((data, index)=>(
                    <tr key={data._id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-start text-capitalize">{data.title}</td>
                        <td className="text-start text-capitalize">
                            <iframe width="300px" src={`https://www.youtube.com/embed/${data.youtube}?playlist=${data.youtube}&playsinline=1`} className='' allow="autoplay; encrypted-media; gyroscope"></iframe>
                        </td>
                        <td className="text-center">{data.active === true ? <span className="badge bg-success">Enable</span> : <span className="badge bg-danger">Disable</span>}</td>
                        <td className="text-center">
                            <EditButton>{`/admin/page/homefest/video/${data._id}`}</EditButton>
                        </td>
                        <td className="text-center">
                            <DeleteButton url="/landingPage/review" id={data._id} />
                        </td>
                    </tr>
                    ))}
                </tbody>
            </TableContainer>
        </DataView>
    </div>
    </ContentLayout>
    )
}
